/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import config from "/public/config";

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  async loadSideTopImage({ commit, state, dispatch }) {
    // 로컬 스토리지에 `${host_name}_side_top_image` 키로 저장된 이미지가 있는지 확인한다.
    if (localStorage.getItem(`${config.HOST_NAME}_side_top_image`)) {
      const cachedImage = localStorage.getItem(`${config.HOST_NAME}_side_top_image`);
      commit('SET_SIDE_TOP_IMAGE', cachedImage);
    }

    // 이미지가 로드되었으면 새로고침하기 전에는 더 이상 로드하지 않는다
    if (state.isLoadedSideTopImage) return;

    const configValue = await dispatch("keyValue/LOAD_CONFIG", {
      key: "side_top_image",
    });

    // 로컬 스토리지에 저장한다
    if (configValue.path) {
      localStorage.setItem(`${config.HOST_NAME}_side_top_image`, configValue.path);

      commit('SET_SIDE_TOP_IMAGE', configValue.path);
      commit('SET_IS_LOADED_SIDE_TOP_IMAGE', true);
    }
  },
  async loadSideTopImageStyle({ commit, state, dispatch }) {
    const storageKey = `${config.HOST_NAME}_side_top_image_style`;
    // 로컬 스토리지에 `${config.HOST_NAME}_side_top_image_style` 키로 저장된 이미지가 있는지 확인한다.
    if (localStorage.getItem(storageKey)) {
      const cachedStyle = localStorage.getItem(storageKey);
      try {
        commit('SET_SIDE_TOP_IMAGE_STYLE', JSON.parse(cachedStyle));
      } catch (e) {
        // console.error(e);
      }
    }

    // 이미지가 로드되었으면 새로고침하기 전에는 더 이상 로드하지 않는다
    if (state.isLoadedSideTopImageStyle) return;

    const configValue = await dispatch("keyValue/LOAD_CONFIG", {
      key: "side_top_image_style",
    });

    // 로컬 스토리지에 저장한다
    localStorage.setItem(storageKey, JSON.stringify(configValue));

    commit('SET_SIDE_TOP_IMAGE_STYLE', configValue);
    commit('SET_IS_LOADED_SIDE_TOP_IMAGE_STYLE', true);
  },
}

export default actions
